import React, { useState } from 'react';
import { XIcon, AlertCircleIcon } from 'lucide-react';
interface StudentCancelLessonModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  lessonTitle?: string;
  teacherName?: string;
  isDark: boolean;
}
export const StudentCancelLessonModal: React.FC<StudentCancelLessonModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  lessonTitle,
  teacherName,
  isDark
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  if (!isOpen) return null;
  const handleConfirm = async () => {
    setIsSubmitting(true);
    try {
      await onConfirm();
    } finally {
      setIsSubmitting(false);
    }
  };
  return <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4" data-id="element-2321">
      <div className={`${isDark ? 'bg-navy-800' : 'bg-white'} rounded-xl p-6 w-full max-w-md`} onClick={e => e.stopPropagation()} data-id="element-2322">
        {/* Header */}
        <div className="flex justify-between items-center mb-4" data-id="element-2323">
          <h3 className={`text-xl font-bold ${isDark ? 'text-white' : 'text-gray-800'}`} data-id="element-2324">
            Cancel Lesson?
          </h3>
          <button onClick={onClose} disabled={isSubmitting} className={`${isDark ? 'text-gray-400 hover:text-white' : 'text-gray-500 hover:text-gray-700'} disabled:opacity-50`} data-id="element-2325">
            <XIcon className="h-5 w-5" data-id="element-2326" />
          </button>
        </div>

        {/* Warning message */}
        <div className={`mb-4 p-3 rounded-lg ${isDark ? 'bg-yellow-500/20 border border-yellow-500/30' : 'bg-yellow-50 border border-yellow-200'}`} data-id="element-2327">
          <div className="flex items-start" data-id="element-2328">
            <AlertCircleIcon className="h-5 w-5 text-yellow-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-2329" />
            <p className={`text-sm ${isDark ? 'text-gray-300' : 'text-gray-700'}`} data-id="element-2330">
              Are you sure you want to cancel this lesson? Please notify your
              teacher as soon as possible.
            </p>
          </div>
        </div>

        {/* Lesson details */}
        {(lessonTitle || teacherName) && <div className={`mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-2331">
            {lessonTitle && <p className="text-sm" data-id="element-2332">
                <span className="font-medium" data-id="element-2333">Lesson:</span> {lessonTitle}
              </p>}
            {teacherName && <p className="text-sm" data-id="element-2334">
                <span className="font-medium" data-id="element-2335">Teacher:</span> {teacherName}
              </p>}
          </div>}

        {/* Action buttons */}
        <div className="flex justify-end gap-3" data-id="element-2336">
          <button onClick={onClose} disabled={isSubmitting} className={`px-4 py-2 rounded-lg ${isDark ? 'bg-navy-700 hover:bg-navy-600 text-white' : 'bg-gray-200 hover:bg-gray-300 text-gray-800'} disabled:opacity-50`} data-id="element-2337">
            Keep Lesson
          </button>
          <button onClick={handleConfirm} disabled={isSubmitting} className={`px-4 py-2 rounded-lg bg-red-500 hover:bg-red-600 text-white disabled:opacity-50 disabled:cursor-not-allowed`} data-id="element-2338">
            {isSubmitting ? 'Canceling...' : 'Cancel Lesson'}
          </button>
        </div>
      </div>
    </div>;
};